import { apiIsomorphicFetchUserEnvironment } from 'api/userEnvironment/apiFetchUserEnvironment';
import { redirectRequireAuthentication } from 'modules/auth/routing/redirect-require-authentication';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';
import type { HorizonLoaderFunctionArgs } from 'routing/types/HorizonLoaderFunctionArgs';

import { AdminsLinksLoadable } from './AdminsLinksLoadable';

export async function loader({
  request,
  context,
}: HorizonLoaderFunctionArgs<void>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    AdminsLinksLoadable.load(),
  ]);

  if (!user) return redirectRequireAuthentication({ request });
}

export default function OrgDashboardAdminsLinksHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <AdminsLinksLoadable />;
}
